export default {
  'pages.marketingCampaigns.title': 'الحملات التسويقية (تم النقل)',
  'pages.marketingCampaigns.name': 'العنوان',
  'pages.marketingCampaigns.id': 'رقم الحملة',
  'pages.marketingCampaigns.creationDate': 'تاريخ الإنشاء',
  'pages.marketingCampaigns.startDateFilter': 'تاريخ البداية',
  'pages.marketingCampaigns.expiryDateFilter': 'تاريخ الانتهاء',
  'pages.marketingCampaigns.status': 'الحالة',
  'pages.marketingCampaigns.active': 'نشطة',
  'pages.marketingCampaigns.inactive': 'غير نشطة',
  'pages.marketingCampaigns.code': 'كود العرض',
  'pages.marketingCampaigns.start': 'تاريخ ووقت البداية',
  'pages.marketingCampaigns.expiry': 'تاريخ ووقت الانتهاء',
  'pages.marketingCampaigns.benefit': 'الميزة',
  'pages.marketingCampaigns.discount': 'الخصم',
  'pages.marketingCampaigns.capping': 'الحد الأقصى للخصم (جنيه)',
  'pages.marketingCampaigns.deactivationDate': 'تاريخ إيقاف الحملة',
  'pages.marketingCampaigns.reason': 'سبب الإيقاف',
  'pages.marketingCampaigns.actions': 'الإجراءات',
  'pages.marketingCampaigns.edit': 'تعديل الحملة',
  'pages.marketingCampaigns.deactivate': 'إيقاف الحملة',
  'pages.marketingCampaigns.deactivateTitle': 'إيقاف الحملة',
  'pages.marketingCampaigns.deactivateConfirmation':
    'هل أنت متأكد من رغبتك في إيقاف هذه الحملة؟',
  'pages.marketingCampaigns.confirm': 'تأكيد',
  'pages.marketingCampaigns.cancel': 'إلغاء',
  'pages.marketingCampaigns.reactivate': 'إعادة تفعيل الحملة',
  'pages.marketingCampaigns.export': 'تصدير أكواد العرض',
  'pages.marketingCampaigns.searchText': 'بحث',
  'pages.marketingCampaigns.searchHint': 'الاسم، الرقم، كود العرض',
  'pages.marketingCampaigns.moreActions': 'المزيد من الإجراءات',
  'pages.marketingCampaigns.currentCampaign': 'تفاصيل الحملة الحالية',
  'pages.marketingCampaigns.maxUsesMinimum':
    'يجب أن يكون حد استخدام الحملة ١ على الأقل',
  'pages.marketingCampaigns.prefixHint': 'استخدم حتى ٣ حروف أو أرقام',
  'pages.marketingCampaigns.fees': 'خصم على رسوم الجمعية',
  'pages.marketingCampaigns.installments': 'خصم على الأقساط',
  'pages.marketingCampaigns.search': 'بحث',
  'pages.marketingCampaigns.clear': 'مسح',
  'pages.marketingCampaigns.create': 'إنشاء حملة',
  'pages.marketingCampaigns.saved': 'تم حفظ الحملة بنجاح',
  'pages.marketingCampaigns.failed': 'تعذر تنفيذ طلب الحملة',
  'pages.marketingCampaigns.eligibility': 'المستخدمون المؤهلون',
  'pages.marketingCampaigns.allUsers': 'كل المستخدمين',
  'pages.marketingCampaigns.uploadUsers': 'رفع قائمة مستخدمين',
  'pages.marketingCampaigns.filters': 'الفلاتر',
  'pages.marketingCampaigns.userTypes': 'أنواع المستخدمين',
  'pages.marketingCampaigns.individual': 'فردي',
  'pages.marketingCampaigns.corporate': 'خصم من الراتب',
  'pages.marketingCampaigns.selfPay': 'دفع ذاتي للشركات',
  'pages.marketingCampaigns.segments': 'شرائح المستخدمين',
  'pages.marketingCampaigns.newUsers': 'مستخدمون جدد',
  'pages.marketingCampaigns.retainedUsers': 'مستخدمون حاليون',
  'pages.marketingCampaigns.firstTimer': 'أول مرة',
  'pages.marketingCampaigns.organizations': 'المؤسسات (اكتب ٣ أحرف على الأقل)',
  'pages.marketingCampaigns.csvOnly': 'اختر ملف CSV',
  'pages.marketingCampaigns.csvLimit':
    'هل تريد استخدام أول ١٠٠٬٠٠٠ مستخدم من الملف؟',
  'pages.marketingCampaigns.template': 'تنزيل النموذج',
  'pages.marketingCampaigns.csvUpload': 'رفع ملف CSV بمعرفات المستخدمين',
  'pages.marketingCampaigns.csvRequirementsTitle': 'كيفية تجهيز ملف CSV',
  'pages.marketingCampaigns.csvFileType': 'ارفع ملفاً بصيغة ‎.csv‎.',
  'pages.marketingCampaigns.csvFirstColumn':
    'ضع معرّف كل مستخدم مؤهل في العمود الأول.',
  'pages.marketingCampaigns.csvOneUserPerRow':
    'ضع معرّف مستخدم مؤهل واحداً في كل صف.',
  'pages.marketingCampaigns.csvNonEmptyValues':
    'سيتم استيراد كل قيمة غير فارغة في العمود الأول.',
  'pages.marketingCampaigns.csvSelectPrompt':
    'اختر ملف CSV للمستخدمين المؤهلين',
  'pages.marketingCampaigns.eligibilityValuesLoaded': 'قيمة أهلية تم تحميلها',
  'pages.marketingCampaigns.removeFile': 'حذف الملف',
  'pages.marketingCampaigns.userCount': 'عدد المستخدمين',
  'pages.marketingCampaigns.required': 'هذا الحقل مطلوب',
  'pages.marketingCampaigns.description': 'الوصف',
  'pages.marketingCampaigns.dateOrder':
    'يجب أن يكون وقت الانتهاء بعد وقت البداية',
  'pages.marketingCampaigns.budget': 'حد الميزانية (جنيه)',
  'pages.marketingCampaigns.maxUses': 'حد استخدام الحملة',
  'pages.marketingCampaigns.usesPerUser': 'حد الاستخدام لكل مستخدم',
  'pages.marketingCampaigns.noLimit': 'بدون حد',
  'pages.marketingCampaigns.retry': 'إعادة المحاولة',
  'pages.marketingCampaigns.benefits': 'المزايا',
  'pages.marketingCampaigns.configuration': 'إعدادات الحملة',
  'pages.marketingCampaigns.codeTaken': 'كود العرض مستخدم بالفعل',
  'pages.marketingCampaigns.compatibility': 'توافق الخصم',
  'pages.marketingCampaigns.override': 'استبدال الخصم',
  'pages.marketingCampaigns.addOnTop': 'إضافة إلى الخصم',
  'pages.marketingCampaigns.notCompatible': 'غير متوافق',
  'pages.marketingCampaigns.fixed': 'مبلغ ثابت (جنيه)',
  'pages.marketingCampaigns.percentage': 'النسبة المئوية',
  'pages.marketingCampaigns.slotsRequired': 'اختر دوراً مؤهلاً واحداً على الأقل',
  'pages.marketingCampaigns.monthsRequired': 'اختر الأشهر المخفضة',
  'pages.marketingCampaigns.discountedMonths': 'الأشهر المخفضة',
  'pages.marketingCampaigns.eligibleSlots': 'الأدوار المؤهلة',
  'pages.marketingCampaigns.amountFrom': 'الحد الأدنى لمبلغ الجمعية',
  'pages.marketingCampaigns.amountTo': 'الحد الأقصى لمبلغ الجمعية',
  'pages.marketingCampaigns.amountOrder':
    'اختر الحدين بحيث لا يتجاوز الأدنى الأقصى',
  'pages.marketingCampaigns.codeMode': 'نوع كود العرض',
  'pages.marketingCampaigns.generated': 'أكواد مولدة تلقائياً',
  'pages.marketingCampaigns.specific': 'كود محدد',
  'pages.marketingCampaigns.prefix': 'بادئة الكود',
  'pages.marketingCampaigns.codeCount': 'عدد الأكواد',
  'pages.marketingCampaigns.codeLength': 'يجب أن يحتوي الكود على ٥ إلى ١٥ حرفاً',
  'pages.marketingCampaigns.back': 'العودة إلى الحملات',
  'pages.marketingCampaigns.previous': 'السابق',
  'pages.marketingCampaigns.next': 'التالي',
  'pages.marketingCampaigns.save': 'حفظ',
  'pages.marketingCampaigns.details': 'تفاصيل الحملة',
  'pages.marketingCampaigns.multipleCodes': 'أكواد متعددة',
  'pages.marketingCampaigns.none': 'بدون ميزة',
  'pages.marketingCampaigns.budgetUsed': 'الميزانية المستخدمة (جنيه)',
  'pages.marketingCampaigns.actualUses': 'الاستخدامات الفعلية',
};
